import script from "./PlayoutLimitWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutLimitWarning.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__